import { configureStore } from "@reduxjs/toolkit";
import jobFilterSlice from "./slices/JobFilterSlice";
import jobSearchSlice from "./slices/JobSearchSlice";

export const store = configureStore({
  reducer: {
    jobFilter: jobFilterSlice,
    jobSearch: jobSearchSlice
  }
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
